import React, { useState, useEffect } from 'react';

const GoToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 200);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToTop}
      style={{
        position: 'fixed',
        bottom: '32px',
        right: '1px',
        zIndex: 1000,
        display: visible ? 'block' : 'none',
        background: '#ffa600', // theme color
        color: '#fff',
        border: 'none',
        borderRadius: '50%',
        width: '48px',
        height: '48px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        cursor: 'pointer',
        fontSize: '2rem',
        transition: 'background 0.3s',
      }}
      onMouseOver={e => (e.currentTarget.style.background = '#ffb733')}
      onMouseOut={e => (e.currentTarget.style.background = '#ffa600')}
      aria-label="Go to top"
    >
      ↑
    </button>
  );
};

export default GoToTop; 